import type { DateKey } from '@features/quote/utils/dateKey';
import type { DerivedScheduleServiceEntry } from '../types/derivedSchedule.types';

// Rows whose stored date no longer matches derivedRows[row].dueDate — the
// guided-visible slice, not the full list, so a hidden row is inert here.
export function unhonouredOverrides(
    dateOverrides: Record<number, DateKey>,
    derivedRows: DerivedScheduleServiceEntry[]
): number[] {
    return Object.entries(dateOverrides)
        .map(([key, date]) => [Number(key), date] as const)
        .filter(([row]) => Number.isInteger(row) && row >= 0 && row < derivedRows.length)
        .filter(([row, date]) => derivedRows[row].dueDate !== date)
        .map(([row]) => row);
}
